<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="900px" persistent scrollable>
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">calendar_today</v-icon>
                {{ isEdit ? 'Modifica Scadenza' : 'Nuova Scadenza' }}
            </v-card-title>

            <v-divider />

            <v-card-text class="pt-6">
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <!-- Tipologia Scadenza -->
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="form.tipologiaScadenzaId" :items="tipologie" item-text="nome"
                                item-value="id" label="Tipologia *" outlined dense :rules="[rules.required]"
                                @change="onTipologiaChange" hide-details>
                                <template v-slot:selection="{ item }">
                                    <v-icon :color="item.coloreHex" small class="mr-2 material-symbols-outlined">
                                        {{ item.iconaMaterial }}
                                    </v-icon>
                                    {{ item.nome }}
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-icon>
                                        <v-icon :color="item.coloreHex" class="material-symbols-outlined">{{
                                            item.iconaMaterial }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.nome }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ item.categoria }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <!-- Data Scadenza -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.dataScadenza" label="Data Scadenza *"
                                prepend-inner-icon="calendar_month" outlined dense :rules="[rules.required]" type="date"
                                hide-details />
                        </v-col>

                        <!-- Titolo -->
                        <v-col cols="12">
                            <v-text-field v-model="form.titolo" label="Titolo *" outlined dense
                                :rules="[rules.required]" counter="100" maxlength="100" />
                        </v-col>

                        <!-- Campi Dinamici in base alla tipologia -->

                        <!-- Targa (per mezzi) -->
                        <v-col cols="12" md="12" v-if="mostraCampo('targa')">
                            <v-autocomplete v-model="form.targa" :items="targhe" label="Targa" outlined dense
                                prepend-inner-icon="car" :rules="richiedeCampo('targa') ? [rules.required] : []" />
                        </v-col>

                        <!-- PC/Dispositivo (per software/IT) -->
                        <v-col cols="12" md="12" v-if="mostraCampo('nomePc')">
                            <v-autocomplete v-model="form.nomePc" :items="pc" label="PC / Dispositivo" outlined dense
                                prepend-inner-icon="laptop" :rules="richiedeCampo('nomePc') ? [rules.required] : []" />
                        </v-col>

                        <!-- Operatore (per corsi/visite) -->
                        <v-col cols="12" md="12" v-if="mostraCampo('operatore')">
                            <v-autocomplete v-model="form.operatore" :items="operatori" label="Operatore" outlined dense
                                prepend-inner-icon="account"
                                :rules="richiedeCampo('operatore') ? [rules.required] : []" /> </v-col>

                        <!-- Priorità -->
                        <v-col cols="12" md="4">
                            <v-select v-model="form.prioritaId" :items="priorita" item-text="label" item-value="id"
                                label="Priorità *" outlined dense :rules="[rules.required]">
                                <template v-slot:selection="{ item }">
                                    <v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>
                                    {{ item.label }}
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>
                                    {{ item.label }}
                                </template>
                            </v-select>
                        </v-col>

                        <!-- Importo -->
                        <v-col cols="12" md="4">
                            <v-text-field v-model.number="form.importo" label="Importo (€)" outlined dense type="number"
                                step="0.01" min="0" prepend-inner-icon="euro"></v-text-field>
                        </v-col>

                        <!-- Responsabile -->
                        <v-col cols="12" md="4">
                            <v-text-field v-model="form.responsabile" label="Responsabile" outlined dense
                                prepend-inner-icon="person_search"></v-text-field>
                        </v-col>

                        <!-- Ricorrenza -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model.number="form.ricorrenzaMesi" label="Ricorrenza (mesi)" outlined dense
                                type="number" min="0" prepend-inner-icon="refresh"
                                hint="0 o vuoto = evento singolo, >0 = ricorrente" persistent-hint></v-text-field>
                        </v-col>

                        <!-- Giorni Preavviso -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model.number="form.giorniPreavviso" label="Giorni Preavviso *" outlined
                                dense type="number" min="1" prepend-inner-icon="notification_important"
                                :rules="[rules.required, rules.positiveNumber]"
                                hint="Numero di giorni prima della scadenza per l'avviso"
                                persistent-hint></v-text-field>
                        </v-col>

                        <!-- Tipo Notifica -->
                        <v-col cols="12">
                            <div class="text-subtitle-2 mb-2">Tipo Notifica *</div>
                            <v-chip-group v-model="tipoNotifica" active-class="primary--text" mandatory>
                                <v-chip value="mail">
                                    <v-icon left small class="material-symbols-outlined">mark_email_read</v-icon>
                                    Solo Email
                                </v-chip>
                                <v-chip value="push">
                                    <v-icon left small class="material-symbols-outlined">add_alert</v-icon>
                                    Solo Notifica
                                </v-chip>
                                <v-chip value="entrambi">
                                    <v-icon left small class="material-symbols-outlined">notification_multiple</v-icon>
                                    Entrambi
                                </v-chip>
                            </v-chip-group>
                        </v-col>

                        <!-- Note -->
                        <v-col cols="12">
                            <v-textarea v-model="form.note" label="Note" outlined dense rows="3" counter="500"
                                maxlength="500"></v-textarea>
                        </v-col>

                        <!-- Allegati -->
                        <!-- <v-col cols="12">
                            <div class="text-subtitle-2 mb-2">
                                <v-icon small class="mr-1">attach_file</v-icon>
                                Allegati
                            </div>

                            <v-list dense v-if="allegati.length > 0" class="mb-3">
                                <v-list-item v-for="(allegato, index) in allegati" :key="allegato.id || `new-${index}`"
                                    class="px-0">
                                    <v-list-item-icon>
                                        <v-icon>description</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ allegato.nomeFile }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="allegato.dimensioneBytes">
                                            {{ formatFileSize(allegato.dimensioneBytes) }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon small color="primary" @click="downloadAllegato(allegato)"
                                            v-if="allegato.id">
                                            <v-icon small>download</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                    <v-list-item-action>
                                        <v-btn icon small color="error" @click="rimuoviAllegato(index)">
                                            <v-icon small>delete</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>

                            <v-file-input v-model="nuoviFile" label="Aggiungi allegati" outlined dense multiple
                                prepend-icon="attach_file" show-size counter :rules="[rules.fileSize]"
                                @change="onFileChange">
                                <template v-slot:selection="{ text, index }">
                                    <v-chip small label color="primary" v-if="index < 2">
                                        {{ text }}
                                    </v-chip>
                                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                        +{{ nuoviFile.length - 2 }} File(s)
                                    </span>
                                </template>
                            </v-file-input>
                        </v-col> -->
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="annulla">
                    Annulla
                </v-btn>
                <v-btn color="primary" :loading="saving" :disabled="!valid" @click="salva">
                    <v-icon left>save</v-icon>
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    createScadenza,
    updateScadenza,
    uploadAllegato,
    getAllegati,
    deleteAllegato,
    downloadAllegato
} from '@/api/api.scadenze.js';

export default {
    name: 'ScadenzaFormDialog',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        scadenza: {
            type: Object,
            default: null
        },
        tipologie: {
            type: Array,
            default: () => []
        },
        targhe: {
            type: Array,
            default: () => []
        },
        pc: {
            type: Array,
            default: () => []
        },
        operatori: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            valid: false,
            saving: false,
            menuData: false,

            form: {
                id: null,
                tipologiaScadenzaId: null,
                dataScadenza: null,
                titolo: '',
                note: '',
                importo: null,
                responsabile: '',
                prioritaId: 2, // Media di default
                targa: null,
                nomePc: null,
                operatore: null,
                ricorrenzaMesi: null,
                giorniPreavviso: 7,
                notificaMail: true,
                notificaPush: false
            },

            tipoNotifica: 'mail',

            tipologiaSelezionata: null,
            allegati: [],
            allegatiDaEliminare: [],
            nuoviFile: [],
            priorita: [
                { id: 1, label: 'Bassa', color: 'green', icon: 'error_outline' },
                { id: 2, label: 'Media', color: 'orange', icon: 'error' },
                { id: 3, label: 'Alta', color: 'red', icon: 'report_gmailerrorred' }
            ],

            rules: {
                required: v => !!v || 'Campo obbligatorio',
                positiveNumber: v => v > 0 || 'Deve essere maggiore di 0',
                fileSize: files => {
                    if (!files || files.length === 0) return true;
                    const maxSize = 10 * 1024 * 1024; // 10MB
                    const invalid = files.find(f => f.size > maxSize);
                    return !invalid || 'File troppo grande (max 10MB)';
                }
            }
        };
    },

    computed: {
        isEdit() {
            return !!this.scadenza?.id;
        }
    },

    watch: {
        value(val) {
            if (val) {
                this.inizializzaForm();
            } else {
                this.resetForm();
            }
        },

        tipoNotifica(val) {
            if (val === 'mail') {
                this.form.notificaMail = true;
                this.form.notificaPush = false;
            } else if (val === 'push') {
                this.form.notificaMail = false;
                this.form.notificaPush = true;
            } else {
                this.form.notificaMail = true;
                this.form.notificaPush = true;
            }
        }
    },

    methods: {
        async inizializzaForm() {
            if (this.scadenza) {
                // Modalità modifica
                this.form = {
                    id: this.scadenza.id,
                    tipologiaScadenzaId: this.scadenza.tipologiaScadenzaId,
                    dataScadenza: this.scadenza.dataScadenza?.split('T')[0] || null,
                    titolo: this.scadenza.titolo,
                    note: this.scadenza.note || '',
                    importo: this.scadenza.importo,
                    responsabile: this.scadenza.responsabile || '',
                    prioritaId: this.scadenza.prioritaId,
                    targa: this.scadenza.targa,
                    nomePc: this.scadenza.nomePc,
                    operatore: this.scadenza.operatore,
                    ricorrenzaMesi: this.scadenza.ricorrenzaMesi,
                    giorniPreavviso: this.scadenza.giorniPreavviso,
                    notificaMail: this.scadenza.notificaMail,
                    notificaPush: this.scadenza.notificaPush
                };

                // Imposta tipo notifica
                if (this.form.notificaMail && this.form.notificaPush) {
                    this.tipoNotifica = 'entrambi';
                } else if (this.form.notificaMail) {
                    this.tipoNotifica = 'mail';
                } else {
                    this.tipoNotifica = 'push';
                }

                // Carica allegati esistenti
                if (this.scadenza.id) {
                    await this.caricaAllegati(this.scadenza.id);
                }

                // Imposta tipologia selezionata
                this.onTipologiaChange();
            } else {
                // Modalità inserimento
                this.resetForm();
            }

            // Reset validazione
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            });
        },

        resetForm() {
            this.form = {
                id: null,
                tipologiaScadenzaId: null,
                dataScadenza: null,
                titolo: '',
                note: '',
                importo: null,
                responsabile: '',
                prioritaId: 2,
                targa: null,
                nomePc: null,
                operatore: null,
                ricorrenzaMesi: null,
                giorniPreavviso: 7,
                notificaMail: true,
                notificaPush: false
            };
            this.tipoNotifica = 'mail';
            this.tipologiaSelezionata = null;
            this.allegati = [];
            this.allegatiDaEliminare = [];
            this.nuoviFile = [];

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },

        onTipologiaChange() {
            if (this.form.tipologiaScadenzaId) {
                this.tipologiaSelezionata = this.tipologie.find(
                    t => t.id === this.form.tipologiaScadenzaId
                );

                // Imposta valori di default dalla tipologia
                if (this.tipologiaSelezionata && !this.isEdit) {
                    this.form.giorniPreavviso = this.tipologiaSelezionata.giorniPreavvisoDefault || 7;
                    this.form.ricorrenzaMesi = this.tipologiaSelezionata.ricorrenzaMesiDefault;
                }
            }
        },

        mostraCampo(campo) {
            if (!this.tipologiaSelezionata) return false;
            try {
                const campiRichiesti = JSON.parse(this.tipologiaSelezionata.campiRichiesti || '[]');
                return campiRichiesti.includes(campo);
            } catch {
                return false;
            }
        },

        richiedeCampo(campo) {
            return this.mostraCampo(campo);
        },

        async caricaAllegati(scadenzaId) {
            try {
                const response = await getAllegati(scadenzaId);
                this.allegati = response.data.data || [];
            } catch (error) {
                console.error('Errore caricamento allegati:', error);
            }
        },

        onFileChange(files) {
            if (files && files.length > 0) {
                files.forEach(file => {
                    this.allegati.push({
                        nomeFile: file.name,
                        dimensioneBytes: file.size,
                        file: file
                    });
                });
                this.nuoviFile = [];
            }
        },

        rimuoviAllegato(index) {
            const allegato = this.allegati[index];
            if (allegato.id) {
                this.allegatiDaEliminare.push(allegato.id);
            }
            this.allegati.splice(index, 1);
        },

        async downloadAllegato(allegato) {
            if (!allegato.id) return;

            try {
                const response = await downloadAllegato(allegato.id);
                const url = window.URL.createObjectURL(new Blob([response.data.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', allegato.nomeFile);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                this.$emit('error', 'Errore nel download dell\'allegato');
                console.error(error);
            }
        },

        async salva() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;

            try {
                let scadenzaId = this.form.id;

                // Salva o aggiorna scadenza
                const payload = { ...this.form };

                if (this.isEdit) {
                    await updateScadenza(scadenzaId, payload);
                } else {
                    const response = await createScadenza(payload);
                    scadenzaId = response.data.data.id;
                }

                // Elimina allegati marcati per eliminazione
                for (const allegatoId of this.allegatiDaEliminare) {
                    await deleteAllegato(allegatoId);
                }

                // Upload nuovi allegati
                const allegatiDaCaricare = this.allegati.filter(a => a.file);
                for (const allegato of allegatiDaCaricare) {
                    await uploadAllegato(scadenzaId, allegato.file);
                }

                this.$emit('saved');
                this.resetForm();
            } catch (error) {
                this.$emit('error', 'Errore nel salvataggio della scadenza');
                console.error(error);
            } finally {
                this.saving = false;
            }
        },

        annulla() {
            this.$emit('close');
            this.resetForm();
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
        }
    }
};
</script>